import {
    collection,
    doc, serverTimestamp,
    setDoc
} from "firebase/firestore";
import { nanoid } from "nanoid";
import { useEffect, useState } from "react";
import { useFirestore, useFirestoreCollectionData } from "reactfire";
import { Project } from "../game/types/project";
import useAllMaps from "./UseAllMaps";
import useAllUnits from "./UseAllUnits";
import useAllBuildings from "./UseAllBuildings";
import useAllResources from "./UseAllResources";

type AllProjectReturn = {
    data: Project[];
    status: "loading" | "error" | "success";
    addProject: (callback: (id: string) => void) => void;
};

export default function useAllProjects(): AllProjectReturn {
    const DB = useFirestore();
    const COLLECTION = "gameProjects";
    const [id, setId] = useState('');

    const allProjects = collection(DB, COLLECTION);

    const { status, data } = useFirestoreCollectionData(allProjects);

    useEffect(() => {
        setId(nanoid());
    }, []);

    const { addMap } = useAllMaps({ projectId: id });
    const { addUnit } = useAllUnits({ projectId: id });
    const { addBuilding } = useAllBuildings({ projectId: id });
    const { addResource } = useAllResources({ projectId: id });

    const addProject = async (callback: (id: string) => void) => {
        addMap(async (mapId: string) => {
            const config: Project = {
                name: "New Project",
                id,
                maps: [mapId],
                units: [],
                buildings: [],
                resource: [],
                lastUpdated: serverTimestamp(),
                created: serverTimestamp(),
            };

            await setDoc(doc(DB, COLLECTION, id), config);

            callback(id)
        });
    };

    // const updateProject = async ({
    //     id,
    //     data,
    // }: {
    //     id: string;
    //     data: ModifiedGameConfig;
    // }) => {
    //     const userCoreRef = doc(DB, COLLECTION, id);

    //     await updateDoc(userCoreRef, data);
    // };

    return {
        data: data as Project[],
        status,
        addProject,
        // updateProject,
    };
}
